import authApi from "interceptor/authInterceptor";
import { get } from "lodash";
import { dispatch } from "store";
import { onBoardingStatusUpdate, onboardedCompanyDetails } from "./auth";
import { updateSelectedCompany } from "./dashboardSearch";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const localStorageWebhookKeys = [
  "onboardActiveStep",
  "onboardPayrollSystem",
  "onboardFormData",
  "webhookPayrollSystem",
];

// State type
interface PayrollOnboardingState {
  onboardFormData: any;
  onboardActiveStep: number;
  onboardPayrollSystem: string;
  isLoading: boolean;
}

const initialState: PayrollOnboardingState = {
  onboardFormData: null,
  onboardActiveStep: 0,
  onboardPayrollSystem: "",
  isLoading: false,
};

const payrollOnboardingSlice = createSlice({
  name: "payrollOnboarding",
  initialState,
  reducers: {
    getOnboardFormData: (state) => {
      const data = JSON.parse(
        localStorage.getItem("onboardFormData") || "null"
      );
      state.onboardFormData = data || initialState.onboardFormData;
    },
    setOnboardFormData: (state, action: PayloadAction<any>) => {
      state.onboardFormData = action.payload || initialState.onboardFormData;
      localStorage.setItem(
        "onboardFormData",
        JSON.stringify(state.onboardFormData)
      );
    },
    getOnboardActiveStep: (state) => {
      const activeStep = JSON.parse(
        localStorage.getItem("onboardActiveStep") || "0"
      );
      state.onboardActiveStep = activeStep || initialState.onboardActiveStep;
    },
    setOnboardActiveStep: (state, action: PayloadAction<number>) => {
      state.onboardActiveStep =
        action.payload ?? initialState.onboardActiveStep;
      localStorage.setItem(
        "onboardActiveStep",
        JSON.stringify(state.onboardActiveStep)
      );
    },
    getOnboardPayrollSystem: (state) => {
      const payrollSystem = localStorage.getItem("onboardPayrollSystem") || "";
      state.onboardPayrollSystem =
        payrollSystem || initialState.onboardPayrollSystem;
    },
    setOnboardPayrollSystem: (state, action: PayloadAction<string>) => {
      state.onboardPayrollSystem =
        action.payload ?? initialState.onboardPayrollSystem;
      localStorage.setItem("onboardPayrollSystem", state.onboardPayrollSystem);
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    clearOnboardingData: () => initialState,
  },
});

export const {
  getOnboardFormData,
  setOnboardFormData,
  getOnboardActiveStep,
  setOnboardActiveStep,
  getOnboardPayrollSystem,
  setOnboardPayrollSystem,
  setIsLoading,
  clearOnboardingData,
} = payrollOnboardingSlice.actions;

export default payrollOnboardingSlice.reducer;

// Thunk function for onboarding timesite pro company
export function onboardCompanyForTimeSiteProPayroll(payload: any) {
  return async () => {
    const response = await authApi.post(`/v2/api/timesitePro/onboard`, payload);
    const companyData = response?.data?.data?.company;

    if (companyData) {
      dispatch(onBoardingStatusUpdate({ onBoardedCompanyData: companyData }));

      const onBoardedUserCompanyDetails = {
        company_name: get(companyData, "company_name", ""),
        _id: get(companyData, "_id", ""),
      };

      dispatch(
        onboardedCompanyDetails({
          onBoardedCompanyDetails: onBoardedUserCompanyDetails,
        })
      );

      dispatch(
        updateSelectedCompany({ selectedCompany: onBoardedUserCompanyDetails })
      );

      dispatch(clearOnboardingData());

      localStorageWebhookKeys.forEach((key) => localStorage.removeItem(key));
    }
  };
}
